import React from "react";
import { TestBox, CheckResult } from "../index";
import PropTypes from "prop-types";
import I18N from "../../I18N";

const TrackingCameraInfo = ({ cameraInfo, handleReTest }) => {
  const { hasCourtLimits } = cameraInfo;
  return (
    <TestBox testName={I18N.t("TRACKING_CAMERA")} handleReTest={handleReTest}>
      <div style={{marginTop: '20px'}}>
        <p>{I18N.t("COURT_LIMITS")}</p>
        <CheckResult isSuccess={hasCourtLimits} />
      </div>
    </TestBox>
  );
};

TrackingCameraInfo.propTypes = {};
TrackingCameraInfo.defaultProps = {};

export default TrackingCameraInfo;
